import { render, staticRenderFns } from "./createPromise.vue?vue&type=template&id=95967bc8"
import script from "./createPromise.vue?vue&type=script&lang=js"
export * from "./createPromise.vue?vue&type=script&lang=js"
import style0 from "./createPromise.vue?vue&type=style&index=0&id=95967bc8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports